export default "__VITE_ASSET__h6ibbH9U__"